export const EMAIL_MAX_LENGTH: number = 100;
export const PHONE_NUMBER_MAX_LENGTH: number = 100;
export const NAME_MAX_LENGTH: number = 200;
export const PASSWORD_MAX_LENGTH: number = 100;
